import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay} from 'swiper/modules';
/* eslint-disable */
const AbtBrand = () => {
  return (
    <>
     <div className="brand-style-three about-brand pb-150">
            <div className="container">
                <div className="brand-slider about-slider swiper-container">
                  <Swiper 
                  slidesPerView={6}
                    spaceBetween={125}
                    loop={true}
                                autoplay={{
                                  delay: 6000,
                                  disableOnInteraction: true,
                                }}
                                roundLengths={true}     
                                modules={[Autoplay]}                     
                                speed={400}
                                breakpoints={{
                                  1600: { slidesPerView: 5 },
                                  1200: { slidesPerView: 5, spaceBetween: 40 },
                                  992: { slidesPerView: 4, spaceBetween: 30 },
                                  768: { slidesPerView: 3, spaceBetween: 20 },
                                  576: { slidesPerView: 2, spaceBetween: 20 },
                                  0: { slidesPerView: 2 },
                                }}
                    className="swiper-wrapper">
                        <SwiperSlide className="swiper-slide xb-brand">
                            <a><img src="assets/img/brand/brand01.webp" alt=""/></a>
                        </SwiperSlide>
                        {/* <SwiperSlide className="swiper-slide xb-brand" >
                            <a><img src="assets/img/brand/brand02.webp"  alt=""/></a>
                        </SwiperSlide> */}
                        <SwiperSlide className="swiper-slide xb-brand">
                            <a><img src="assets/img/brand/brand03.webp" alt=""/></a>
                        </SwiperSlide>
                        <SwiperSlide className="swiper-slide xb-brand">
                            <a><img src="assets/img/brand/brand04.webp" alt=""/></a>
                        </SwiperSlide>
                        <SwiperSlide className="swiper-slide xb-brand">
                            <a><img src="assets/img/brand/brand05.webp" alt=""/></a>
                        </SwiperSlide>
                        <SwiperSlide className="swiper-slide xb-brand">
                            <a><img src="assets/img/brand/brand06.webp" alt=""/></a>
                        </SwiperSlide>
                        <SwiperSlide className="swiper-slide xb-brand">
                            <a><img src="assets/img/brand/brand07.webp" alt=""/></a>
                        </SwiperSlide>
                        <SwiperSlide className="swiper-slide xb-brand">
                            <a><img src="assets/img/brand/brand08.webp" alt=""/></a>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
        </div>
       
    </>
  )
}

export default AbtBrand
/* eslint-enable */